module.exports = __webpack_public_path__ + "static/media/23b.0864768e.jpg";